import { render, staticRenderFns } from "./MasterTable.vue?vue&type=template&id=6965d410"
import script from "./MasterTable.vue?vue&type=script&lang=js"
export * from "./MasterTable.vue?vue&type=script&lang=js"
import style0 from "./MasterTable.vue?vue&type=style&index=0&id=6965d410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports